import { render, staticRenderFns } from "./SidebarAddNewSupplier.vue?vue&type=template&id=bd874a28&"
import script from "./SidebarAddNewSupplier.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewSupplier.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewSupplier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports